import type { RiskEntityPayload } from '@/services/quotes/types';
import type { EntityRiskValues, EntityTab, RiskDataMap } from '../../types';
import { parseNum } from './step-helpers.util';

const ZERO_BAND = { livesQuantity: 0, individualCapital: 0 } as const;

function mapEntityValues(
  documentNumber: string,
  sequenceNumber: number,
  values: EntityRiskValues
): RiskEntityPayload {
  if (values.perfilDoGrupo === 'ESCALONADO') {
    return {
      sequenceNumber,
      documentNumber,
      groupProfile: 'ESCALONADO',
      partnersAndDirectors: {
        livesQuantity: parseNum(values.sdQuantidadeDeVidas),
        individualCapital: parseNum(values.sdCapitalIndividual),
      },
      employees: {
        livesQuantity: parseNum(values.colQuantidadeDeVidas),
        individualCapital: parseNum(values.colCapitalIndividual),
      },
    };
  }

  const band = {
    livesQuantity: parseNum(values.uniQuantidadeDeVidas),
    individualCapital: parseNum(values.uniCapitalIndividual),
  };

  const partnersAndDirectors =
    values.tipoDePerfil === 'COLABORADORES' ? ZERO_BAND : band;
  const employees = values.tipoDePerfil === 'SOCIOS' ? ZERO_BAND : band;

  return {
    sequenceNumber,
    documentNumber,
    groupProfile: 'UNIFORME',
    partnersAndDirectors,
    employees,
  };
}

export function mapRiskDataMapToPayload(
  riskDataMap: RiskDataMap,
  entities: EntityTab[]
): RiskEntityPayload[] {
  const findSequenceNumber = (documentNumber: string): number => {
    if (entities.length === 0) return 0;
    return (
      entities.find(entity => entity.id === documentNumber)?.sequenceNumber ?? 0
    );
  };

  const riskProfileList = Object.entries(riskDataMap).map(([key, values]) =>
    mapEntityValues(key, findSequenceNumber(key), values)
  );

  riskProfileList.sort((a, b) => a.sequenceNumber - b.sequenceNumber);

  return riskProfileList;
}
